import React, { useState, useEffect, useContext } from 'react'
import ProductCommonContext from '../../context/common/commonContext'
import CustomCommonContext from '../../../custom/context/common/commonContext'
import DynamicContext from '../../context/dynamic/dynamicContext'

const InitialFunction = (props) => {
    const { getAllCountries, getAllStates, getAllCities } =
        useContext(ProductCommonContext)
    const { getGlobalVariable } = useContext(CustomCommonContext)
    const {
        getAllDynamicFields,
        getAllDynamicTables,
        getAllDynamicPagesFields,
    } = useContext(DynamicContext)

    useEffect(() => {
        getGlobalVariable()
        getAllDynamicFields({
            page: 1,
            limit: 1000,
            order: 'asc',
            orderby: 'df.show_order',
            table: 'dynamic_fields',
            filters: {},
        })
        getAllDynamicTables({
            page: 1,
            limit: 1000,
            order: 'asc',
            orderby: 'dt.show_order',
            table: 'dynamic_tables',
            filters: {},
        })
        getAllCountries()
        getAllStates()
        getAllCities()
        getAllDynamicPagesFields({
            page: 1,
            limit: 1000,
            order: 'asc',
            orderby: 'dvpi.id',
            primaryTable: 'dynamic_view_page_info',
            filters: {},
        })
    }, [])
    return <></>
}

export default InitialFunction
